module.exports = __webpack_public_path__ + "assets/images/chaohui.8c567f2a73967e69c6d71afde056e07e.png";